import { createContext, useContext } from 'react';

const UploadDocumentContext = createContext(null);

export const useUploadDocumentContext = () => {
  const context = useContext(UploadDocumentContext);
  if (!context) {
    throw Error(
      'useUploadDocumentContext must be called inside a UploadDocumentContextProvider Provider'
    );
  }

  return context;
};

export const UploadDocumentContextProvider = UploadDocumentContext.Provider;
